"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatorViewModel = calculatorViewModel;
function calculatorViewModel(calculator) {
    const title = calculator?.title || calculator?.shortTitle || "";
    const secondaryTitle = undefined;
    return {
        ...calculator,
        title,
        secondaryTitle,
    };
}
